import { CIcon } from '~/icons/types'

export const ciAirsports: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M23.5 10.315h-1.2v-.091a.5.5 0 0 0-1 0v.09h-1.2a.5.5 0 1 0 0 .996h1.2v.507l-5.63-.413v-1.63h2.13v.166a.5.5 0 0 0 1 0V8.429h.55a.5.5 0 1 0 0-1h-.564a.5.5 0 0 0-.967 0h-.563a.5.5 0 0 0 0 1h.544v.35h-2.13v-.8a1.566 1.566 0 0 0-1.535-1.6h-4.28a1.567 1.567 0 0 0-1.534 1.6v.8H6.008v-.35h.55a.5.5 0 0 0 0-1h-.564a.5.5 0 0 0-.967 0h-.563a.5.5 0 1 0 0 1h.549v1.51a.5.5 0 0 0 1 0v-.165H8.32v1.63l-5.621.413v-.507h1.2a.5.5 0 0 0 0-.995H2.672a.495.495 0 0 0-.947 0H.5a.5.5 0 1 0 0 .995h1.2v2.942a.5.5 0 0 0 1 0v-.213h5.62v.052a1.6 1.6 0 0 0 .8 1.4 2.4 2.4 0 0 0-.445 1.132H8.16a.5.5 0 0 0 0 1h.909a.3.3 0 0 0 .067 0 .303.303 0 0 0 .066 0h.88a.5.5 0 0 0 0-1h-.4c.05-.29.205-.553.437-.734.148-.106.32-.175.5-.2h3.217c.157.042.413.284.5.933H13.9a.5.5 0 0 0 0 1h.895a.3.3 0 0 0 .067 0 .303.303 0 0 0 .066 0h.895a.5.5 0 0 0 0-1h-.488a2.801 2.801 0 0 0-.36-1.19 1.607 1.607 0 0 0 .7-1.335v-.058H21.3v.213a.5.5 0 0 0 1 0V11.31h1.2a.5.5 0 1 0 0-.995ZM8.32 13.044H2.7v-.228l5.625-.412-.004.64Zm6.355 1.055a.573.573 0 0 1-.54.6h-4.28a.573.573 0 0 1-.54-.6v-.483a.377.377 0 0 0 0-.067.371.371 0 0 0 0-.066v-1.54a.902.902 0 0 0 0-.1.073.073 0 0 0 0-.03v-3.84a.573.573 0 0 1 .54-.6h4.28a.574.574 0 0 1 .54.6V14.1Zm6.625-1.055h-5.63v-.64l5.629.412v.228Z'
    },
    {
      d:
        'M12 8.832a2.2 2.2 0 1 0 0 4.4 2.2 2.2 0 0 0 0-4.4Zm0 3.4a1.2 1.2 0 1 1 0-2.403 1.2 1.2 0 0 1 0 2.405v-.002Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'airsports',
  type: 'thin'
}
